import React, {useEffect, useState} from 'react'
import useDidMountEffect from "../../../../../../hooks/useDidMountEffect/useDidMountEffect";
import {
    buscarColaboradorAPI, buscarFlujoDocumentoColaboradorAPI,
    getEmpleadoNameAPI,
    getEmpleadosToCreateCondicionAPI, validarRegistrarFlujoDocumentoPaso1API
} from "../../../../../../consumers/backendApisUrls";
import {Div} from "../../../../../registroMaternidad/modales/components/Components";
import InputSelect from "../../../../../../components/modalComponents/InputSelect";
import InputText from "../../../../../../components/modalComponents/InputText";
import InputDate from "../../../../../../components/modalComponents/InputDate";
import InputTextArea from "../../../../../../components/modalComponents/InputTextArea";
import InputUploadFile from "../../../../../../components/modalComponents/InputUploadFile";
import {EXTENSION_PDF} from "../../../../../../constants/hardCodedConstants";
import {AlertErrorMaxFileSizeMessageGeneric} from "../../../../../../components/alerts/AlertErrorMaxFileSizeMessage";
import InputSearchAsync from "../../../../../../components/modalComponents/InputSearchAsync";
import {TipoAdministrador} from "../../../../constantes/constantes";
import {useSubmitForm} from "../../../../../../hooks/useSubmitForm/useSubmitForm";
import {isNullOrUndefinded} from "../../../../../../helper/utils";
import {useManageGetRequest} from "../../../../../../hooks/useManageGetRequest/useManageGetRequest";
import InputBool from "../../../../../../components/modalComponents/InputBool";
import InputCheckBox from "../../../../../../components/modalComponents/InputCheckBox";

const Paso1 = ({
                   sendCurrentStep,
                   setSendCurrentStep,
                   componentStep,
                   KEYS,
                   selectProps,
                   SECTION_NAME,
                   formValues,
                   propsInputs,
                   setFormValues,
                   disableInputs,
                   isCreate
               }) => {
    const [submitForm] = useSubmitForm();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [executeManageGet] = useManageGetRequest();

    useDidMountEffect(() => {
        if (sendCurrentStep?.step === componentStep && sendCurrentStep?.isSent) {
            handleSubmit();
        }
    }, [sendCurrentStep])

    useDidMountEffect(() => {
        if (!isNullOrUndefinded(formValues[KEYS.IdEmpleadoVisorAdministrador])) {
            getEmpleadoVisorAdministradorName();
        }
    }, [formValues[KEYS.IdEmpleadoVisorAdministrador]])

    useDidMountEffect(() => {
        if (!isNullOrUndefinded(formValues[KEYS.IdEmpleadoAdministrador])) {
            getEmpleadoAdministradorName();
        }
    }, [formValues[KEYS.IdEmpleadoAdministrador]])

    useDidMountEffect(() => {
        const tipo = formValues[KEYS.IdTipoVisorAdministrador];

        if (tipo === TipoAdministrador.PorColaborador.Id) {
            setFormValues(prev => ({ ...prev, IdRolVisorAdministrador: undefined }));
        } else if (tipo === TipoAdministrador.PorRol.Id) {
            setFormValues(prev => ({
                ...prev,
                IdEmpleadoVisorAdministrador: undefined,
                EmpleadoVisorAdministrador: undefined,
            }));
        }

    }, [formValues[KEYS.IdTipoVisorAdministrador]]);


    useDidMountEffect(() => {
        const tipo = formValues[KEYS.IdTipoAdministrador];

        if (tipo === TipoAdministrador.PorColaborador.Id) {
            setFormValues(prev => ({ ...prev, IdRolAdministrador: undefined }));
        } else if (tipo === TipoAdministrador.PorRol.Id) {
            setFormValues(prev => ({
                ...prev,
                IdEmpleadoAdministrador: undefined,
                EmpleadoAdministrador: undefined,
            }));
        }

    }, [formValues[KEYS.IdTipoAdministrador]]);


    async function getEmpleadoVisorAdministradorName() {
        try {
            const api = getEmpleadoNameAPI(formValues[KEYS.IdEmpleadoVisorAdministrador]);
            await executeManageGet(api, (res) => successCallbackGetEmpleadoVisorAdministradorName(res), false);
        } catch (error) {
            console.error(error)
        }
    }

    const successCallbackGetEmpleadoVisorAdministradorName = (res) => {
        setFormValues(lastData => ({...lastData, [KEYS.EmpleadoVisorAdministrador]: res?.data}))
    }

    async function getEmpleadoAdministradorName() {
        try {
            const api = getEmpleadoNameAPI(formValues[KEYS.IdEmpleadoAdministrador]);
            await executeManageGet(api, (res) => successCallbackGetEmpleadoAdministradorName(res), false);
        } catch (error) {
            console.error(error)
        }
    }

    const successCallbackGetEmpleadoAdministradorName = (res) => {
        setFormValues(lastData => ({...lastData, [KEYS.EmpleadoAdministrador]: res?.data}))
    }

    const handleSubmit = async (e) => {
        if (e)
            e.preventDefault();

        //setSendCurrentStep(lastData => ({...lastData, isSent: false, isSaved: true}));
        //return
        setIsSubmitting(true);
        let api = "";
        let payload = {}
        let keys = [];

        api = validarRegistrarFlujoDocumentoPaso1API();
        payload = getPayload();
        keys = KEYS;

        try {
            await submitForm(Object.values(keys), api, payload, SECTION_NAME, successSubmitValidarCallback, false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    }
    const successSubmitValidarCallback = async ({data}) => {
        setSendCurrentStep(lastData => ({...lastData, isSent: false, isSaved: true}));
    }

    const getPayload = () => {
        return {
            ...formValues,
        }
    }

    const today = new Date().toISOString().split("T")[0];

    return (
        <div className="displayFlexWrap">
            <Div col={6}>
                <InputText
                    label={"Actividad"}
                    {...propsInputs(KEYS.NombreActividad)}
                    sectionName={SECTION_NAME}
                    direction="column"
                    isRequired={true}
                    isDisabled={disableInputs || !isCreate}
                />
            </Div>
            <Div col={6}>
                <InputText
                    label={"Nombre Documento"}
                    {...propsInputs(KEYS.NombreFlujoDocumento)}
                    sectionName={SECTION_NAME}
                    direction="column"
                    isRequired={true}
                    isDisabled={disableInputs || !isCreate}
                />
            </Div>
            <Div col={6}>
                <InputDate
                    label={"Fecha de inicio"}
                    {...propsInputs(KEYS.FechaInicio)}
                    sectionName={SECTION_NAME}
                    direction="column"
                    isRequired={true}
                    min={isCreate ? today : undefined}
                    max={isCreate ? formValues[KEYS.FechaFin] : undefined}
                    isDisabled={disableInputs}
                />

            </Div>
            <Div col={6}>
                <InputDate
                    label={"Fecha de fin"}
                    {...propsInputs(KEYS.FechaFin)}
                    sectionName={SECTION_NAME}
                    min={isCreate ? (formValues[KEYS.FechaInicio] ?? today) : undefined}
                    direction="column"
                    isRequired={true}
                    isDisabled={disableInputs}
                />
            </Div>
            <Div col={12}>
                <InputTextArea
                    label={"Instrucciones"}
                    {...propsInputs(KEYS.Instrucciones)}
                    sectionName={SECTION_NAME}
                    placeholder={" "}
                    direction="column"
                    isRequired={true}
                    isDisabled={disableInputs}
                />
            </Div>
            <Div col={12} >
                <InputCheckBox
                    label="Incorporar nuevos colaboradores automáticamente (solo si el documento NO contiene extradatas)"
                    {...propsInputs(KEYS.IncorporarNuevosColaboradoresAutomaticamente)}
                    sectionName={SECTION_NAME}
                    isDisabled={disableInputs}
                />
            </Div>
            <Div col={12}>
                <InputCheckBox
                    label="Obligatorio para descargar boleta de pago"
                    {...propsInputs(KEYS.ObligatorioParaDescargarBoletaDePago)}
                    sectionName={SECTION_NAME}
                    isDisabled={disableInputs}
                />
            </Div>
            <Div col={12}>
                <InputUploadFile
                    toolTipText="Adjuntar un solo documento en formato pdf, si posees más de un documento, debes escanear todo como un solo archivo (no mayor de 2MB)"
                    label="Procedimiento"
                    direction="column"
                    name={KEYS.ProcedimientoFile}
                    uploadFile={formValues[KEYS.ProcedimientoFile]}
                    setUploadFile={(res) =>
                        setFormValues({...formValues, [KEYS.ProcedimientoFile]: res})
                    }
                    sectionName={SECTION_NAME}
                    validExtensions={EXTENSION_PDF}
                    isRequired={true}
                    maxFileSize={2097152} //2MB
                    ToastArchivoNoValido={() => AlertErrorMaxFileSizeMessageGeneric('pdf', '2MB')}
                    isDisabled={disableInputs}
                />
            </Div>
            <Div col={12}>
                <p style={{fontWeight: 600}}>Administrador del Documento</p>
            </Div>
            <Div col={12}>
                <InputSelect
                    label="Área"
                    {...selectProps(KEYS.IdAreaAdministrador)}
                    sectionName={SECTION_NAME}
                    isDisabled={disableInputs}
                    isRequired={true}
                    placeholder={"Seleccionar Área"}
                    direction="column"
                />
            </Div>
            <Div col={4}>
                <InputSelect
                    label="Tipo Administrador"
                    {...selectProps(KEYS.IdTipoAdministrador)}
                    sectionName={SECTION_NAME}
                    isDisabled={disableInputs}
                    isRequired={true}
                    placeholder={"Seleccionar Tipo"}
                    direction="column"
                />
            </Div>
            <Div col={8}>
                {TipoAdministrador.PorColaborador.Id === formValues[KEYS.IdTipoAdministrador] &&
                    <InputSearchAsync typeGet label='Empleado'
                                      api={buscarFlujoDocumentoColaboradorAPI}
                                      valueText={formValues.EmpleadoAdministrador}
                                      {...propsInputs(KEYS.IdEmpleadoAdministrador)}
                                      direction="column"
                                      isDisabled={disableInputs}
                    />
                }

                {TipoAdministrador.PorRol.Id === formValues[KEYS.IdTipoAdministrador] &&
                    <InputSelect
                        label="Rol"
                        {...selectProps(KEYS.IdRolAdministrador)}
                        sectionName={SECTION_NAME}
                        placeholder={"Seleccionar Rol Administrador"}
                        direction="column"
                        isDisabled={disableInputs}
                    />
                }
            </Div>
            <Div col={4}>
                <InputSelect
                    label="Tipo Visor Administrador"
                    {...selectProps(KEYS.IdTipoVisorAdministrador)}
                    sectionName={SECTION_NAME}
                    isDisabled={disableInputs}
                    isRequired={true}
                    placeholder={"Seleccionar Tipo"}
                    direction="column"
                />
            </Div>
            <Div col={8}>
                {TipoAdministrador.PorColaborador.Id === formValues[KEYS.IdTipoVisorAdministrador] &&
                    <InputSearchAsync typeGet label='Empleado' api={buscarFlujoDocumentoColaboradorAPI}
                                      valueText={formValues.EmpleadoVisorAdministrador}
                                      {...selectProps(KEYS.IdEmpleadoVisorAdministrador)}
                                      direction="column" isDisabled={disableInputs}/>
                }
                {TipoAdministrador.PorRol.Id === formValues[KEYS.IdTipoVisorAdministrador] &&
                    <InputSelect
                        label="Rol"
                        {...selectProps(KEYS.IdRolVisorAdministrador)}
                        sectionName={SECTION_NAME}
                        isDisabled={disableInputs}
                        placeholder={"Seleccionar Rol Visor Administrador"}
                        direction="column"
                    />
                }
            </Div>
        </div>
    )
}

export default Paso1;